import { glyphIconStyle, convertToLocalStyle, getColumnSolidBorderStyle, inputFieldStyle, truncatedStyle } from '@bingads-webui-campaign-react/common-styles';
import { getBidMultipliersEditorStyle, getBidEditorStyle } from './overview-editor-styles';
import { getOverviewCommonStyles } from './overview-common-style';

export const getOverviewPageStyles = (_, { palette = {} }) => ({
  overviewPage: {
    ...getOverviewCommonStyles(_, { palette }),
    '& .navbar-nav': {
      margin: '0 !important',
    },
    '& .grid-picker': {
      maxHeight: 300,
      '& ul li .selected': {
        background: palette.neutralLighter,
      },
      '& ul li:nth-child(3)': {
        borderBottom: `1px solid ${palette.neutralLight}`,
      },
    },
    '& #bulkEditContainer': {
      '& .bulk-edit-container table .noborder': {
        borderBottomStyle: 'hidden',
        borderLeftStyle: 'hidden',
        borderRightStyle: 'hidden',
      },
      '& .control-label': {
        paddingTop: 0,
        '& label': {
          display: 'inline-block',
        },
      },
      '& .bid-strategy-panel': {
        '& .input-control': {
          paddingTop: 5,
          paddingLeft: 5,
        },
      },
      '& .form-inline': {
        marginBottom: 30,
        '& div': {
          display: 'inline-block',
        },
        '& input[type="checkbox"]': {
          margin: '8px 2px 0 8px',
          top: 3,
          position: 'relative',
        },
        '& input[readonly]': {
          backgroundColor: '#f4f4f4',
        },
        '& .form-text.bold': {
          fontWeight: 600,
        },
        '& span.unit-percent, span.form-text': {
          marginLeft: 2,
        },
        '& .input-control': {
          position: 'relative',
          '& div:nth-child(2)': {
            position: 'absolute',
            left: 0,
            top: 32,
            '& .error': {
              whiteSpace: 'nowrap',
            },
          },
        },
      },
      '& .bid-multipliers-panel': {
        ...getBidMultipliersEditorStyle(),
        '& .bid-multipliers-content > .col-sm-12': {
          padding: 0,
        },
      },
      '& .inline-download-form': {
        '& label:focus-within': {
          outline: 'none',
        },
      },
    },
    '& .hotel-center-overview-grid-container': {
      padding: 0,
    },
    '& .grid-and-disclaim-container': {
      '& .bid-inline-edit-popupeditor': {
        ...getBidEditorStyle(),
        '& .bid-strategy-panel.form-horizontal': {
          '& label.checkbox, label.radio': {
            left: 1,
          },
        },
      },

      '& .bid-multi-inline-edit-popupeditor': {
        width: '715px',
        ...getBidMultipliersEditorStyle(),
      },

      '& .hotel-group-information-container': {
        padding: 0,
        borderTop: `1px solid ${palette.neutralLighter}`,
        '& .margin-zero': {
          margin: 0,
        },
        '& h3': {
          fontSize: 14,
          height: 21,
          lineHeight: '21px',
        },
        '& .col-sm-5, .col-sm-7, .col-sm-8, ': {
          width: 'auto',
          paddingLeft: 8,
          paddingRight: 8,
        },
        '& .col-sm-1, .col-sm-6': {
          padding: 0,
          width: 'auto',
        },
        '& .glyphicon': {
          verticalAlign: 'top',
          cursor: 'pointer',
          height: 21,
          lineHeight: '21px',
        },
      },
    },
    '& .column-chooser .column-chooser-bulk-control': {
      '& .arrow-button': {
        display: 'none',
      },
    },
    '& .HotelSubAccountGrid, .HotelDeviceTypeGrid, .HotelDateGrid, .HotelLengthOfStayGrid, .HotelUserCountryGrid, .HotelSlotTypeGrid, .HotelCountryGrid, .AdvancedBookingGrid, .CheckinDayGrid, .DateTypeGrid, .SiteTypeGrid': {
      ...getColumnSolidBorderStyle(0, 2),
    },
    '& .HotelIdGrid, .HotelGroupGrid': {
      ...getColumnSolidBorderStyle(1, 2),
    },
    ...convertToLocalStyle(glyphIconStyle({ palette })),
    ...convertToLocalStyle(inputFieldStyle({ palette })),
    ...truncatedStyle,
  },
  SubAccountSelectorContainer: {
    width: 220,
    margin: '30px 0 38px 32px',
  },
  '@global': {
    '.hotel-center-overview-subaccount-bar-ui-next-container': {
      '& > div': {
        display: 'flex',
      },
      '& .breadcrumb-text-container': {
        maxWidth: '180px',
      },
      '& .current-breadcrumb': {
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .summary-bar-divider': {
        flex: '0 1 auto',
        height: '32px',
        minWidth: '1px',
        alignSelf: 'center',
        background: '#e1dfdd',
        margin: '0 15px',
      },
      '& .breadcrumb-divider': {
        paddingRight: '8px',
        marginLeft: '-7px',
        '& .iconba-ChevronRight': {
          color: '#605e5c',
          fontSize: '12px',
          fontWeight: 'normal',
        },
      },
      '& .subaccount-bar-breadcrumbs': {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
      },
      '& .subaccount-bar-entity-items': {
        display: 'flex',
        height: '44px',
      },
      '& .subaccount-bar-entity-item': {
        display: 'flex',
        flexDirection: 'column',
        marginRight: '24px',
        minWidth: '90px',
        flexShrink: '0',
      },
      '& .subaccount-bar-entity-label, .subaccount-bar-entity-value': {
        display: 'flex',
        flexShrink: '0',
        '& > span': {
          flexShrink: '0',
        },
      },
      '& .btn ~ .btn': {
        marginLeft: '8px',
      },
      '& .subaccount-bar-bid-multipliers-container': {
        '& .subaccount-bar-entity-item': {
          minWidth: '140px',
        },
      },
      '& .glyphicon.glyphicon-pencil': {
        marginLeft: '10px',
      },
      '& .glyphicon.glyphicon-pencil::before': {
        color: '#005a9e',
        content: '"\\E70F"',
        fontFamily: 'MsAds MDL2 Assets',
      },
      '& .hide': {
        display: 'none !important',
      },
      '& .show': {
        display: 'block !important',
      },
      '& .grid-groupmenu': {
        zIndex: '1090',
        position: 'absolute',
        display: 'none',
        backgroundColor: '#fff',
        border: '2px solid #ccc',
        minWidth: '100px',
        fontSize: '12px',
      },
      height: '44px',
      '& .form-inline': {
        '& .radio': {
          '& input[type="radio"]': {
            marginLeft: '-18px',
          },
        },
      },
      '& .subaccount-bid-multipliers-edit-container': {
        '& .btn-group.col-sm-12': {
          display: 'flex',
          flexWrap: 'wrap',
        },
        width: '735px',
        maxHeight: 500,
        overflow: 'auto',
        '& .bid-multipliers-panel': {
          display: 'flex',
          flexDirection: 'column',
        },
        ...getBidMultipliersEditorStyle(),
      },
      '& .subaccount-bid-edit-panel': {
        width: '500px',
        ...getBidEditorStyle(),
        '& .col-sm-4.control-label': {
          paddingLeft: 8,
        },
        '& .bid-strategy-panel.form-horizontal': {
          '& label.checkbox, label.radio': {
            left: -5,
          },
        },
      },
      '& .budget-edit-panel': {
        width: '300px',
        '& .col-sm-12': {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      '& .bid-cap-edit-panel': {
        width: '400px',
        '& .form-group': {
          display: 'block',
        },
        '& .col-sm-12': {
          padding: 0,
        },
        '& .bid-selection': {
          '& .bid-selection-label': {
            float: 'none',
          },
          '& .col-sm-7': {
            float: 'none',
            marginLeft: 16,
          },
          '& .col-sm-12.radio': {
            padding: 0,
          },
        },
        '& .col-sm-12.radio.form-group': {
          marginLeft: '0px',
        },
        '& .button-panel': {
          marginTop: 16,
        },
      },
      '& label': {
        display: 'inline-block',
      },
      '& ul[role="alert"]': {
        listStyle: 'none',
        paddingLeft: 0,
      },
      '& .error': {
        color: palette.redDark,
      },
      ...getOverviewCommonStyles(_, { palette }),
      ...convertToLocalStyle(inputFieldStyle({ palette })),
    },
  },
});
